import React from 'react';
import { bool, func, object } from 'prop-types';
import {
  CheckboxSetStyled,
  CheckboxStyled,
  ModalStyled,
  ModalActionsStyled,
  TextStyled,
  ButtonStyled,
  Box,
  useTokens
} from '@nike/nike-design-system-components';
import LoadingAnimation from '../../../components/LoadingAnimation';

const INCLUDE_IMAGES_OPTIONS = [
  {
    value: true,
    label: 'Include Images'
  },
  {
    value: false,
    label: 'Do Not Include Images'
  }
];

const DownloadProductsModal = ({
  isOpen,
  closeModal,
  downloadCatalogProductsReport,
  isDownloading,
  isCatalogsList,
  selectedFlatRows,
  includeImages,
  onIncludeImages
}) => {
  const tokens = useTokens();
  const prohibitDownload = isCatalogsList && selectedFlatRows?.length > 25;

  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={closeModal}
      title=''
      modalRootCompProps={{ style: { maxWidth: '800px' } }}
      modalHeaderCompProps={{ style: { paddingBottom: '0' } }}
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      slots={{
        HeaderTitleSlot: (
          <Box
            width='140%'
            paddingBlockEnd='12px'
            style={{ borderBottom: `1px solid ${tokens.podiumCdsColorGrey300}` }}
          >
            <TextStyled appearance='title3'>Download Catalog Products</TextStyled>
            <TextStyled appearance='body2' color={tokens.podiumCdsColorGrey500}>
              The downloaded product assortments will have catalog and product details
            </TextStyled>
          </Box>
        ),
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled
              type='submit'
              appearance='primary'
              onClick={() => downloadCatalogProductsReport({ includeImages })}
              disabled={prohibitDownload || includeImages === null}
            >
              Download
            </ButtonStyled>
            <ButtonStyled type='button' appearance='secondary' onClick={closeModal}>
              Cancel
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
    >
      <Box width='100%' height='100%'>
        <Box>
          <CheckboxSetStyled onChange={onIncludeImages} selectedValues={[includeImages]}>
            {INCLUDE_IMAGES_OPTIONS.map(option => (
              <CheckboxStyled
                style={{ marginLeft: 0 }}
                key={`include-images-${option.value}`}
                id={`include-images-${option.value}`}
                label={option.label}
                value={option.value}
              />
            ))}
          </CheckboxSetStyled>
        </Box>
        <Box paddingBlockEnd='10px' paddingBlockStart='10px'>
          {prohibitDownload ? (
            <TextStyled style={{ fontSize: '16px', paddingTop: '30px', color: 'red' }}>
              You cannot download product details of more than 25 catalogs at a time.
            </TextStyled>
          ) : (
            <TextStyled style={{ fontSize: '16px', paddingTop: '30px' }}>
              Do you want to proceed with downloading the selected catalog/s product assortment details?
            </TextStyled>
          )}
        </Box>
      </Box>
      {isDownloading && (
        <Box
          data-testId='duplicating-overlay'
          width='100%'
          height='75%'
          style={{
            position: 'absolute',
            top: '18%',
            left: '0',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: '3'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '28%',
              left: '33%'
            }}
          >
            <TextStyled width='100%' appearance='title4'>
              DOWNLOADING PRODUCTS...
            </TextStyled>
          </div>

          <LoadingAnimation size='s' />
        </Box>
      )}
    </ModalStyled>
  );
};

DownloadProductsModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  downloadCatalogProductsReport: func.isRequired,
  isDownloading: bool.isRequired,
  isCatalogsList: bool.isRequired,
  selectedFlatRows: object.isRequired,
  includeImages: bool,
  onIncludeImages: func
};

DownloadProductsModal.defaultProps = {
  includeImages: null,
  onIncludeImages: () => {}
};

export default DownloadProductsModal;
